"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.EmptyState = void 0;
var _classnames = _interopRequireDefault(require("classnames"));
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
/**
 * This is a [React](https://reactjs.org/) component to represent an empty state.
 */
const EmptyState = _ref => {
  let {
    children,
    className,
    image,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("div", _extends({
    className: (0, _classnames.default)(["row", className])
  }, props), /*#__PURE__*/_react.default.createElement("div", {
    className: "u-align--right col-4 col-medium-2 col-small-1"
  }, image), /*#__PURE__*/_react.default.createElement("div", {
    className: "u-align--left col-8 col-medium-4 col-small-3"
  }, /*#__PURE__*/_react.default.createElement("p", {
    className: "p-heading--4 u-no-margin--bottom"
  }, title), children));
};
exports.EmptyState = EmptyState;
var _default = exports.default = EmptyState;